import React from "react";
import { DisclosureGroup } from "react-aria-components";

import type { AccordionGroupBlock as Value } from "@reactivated";

import { RichText } from "../RichText";
import { DisclosureRow, type HeadingTag } from "./DisclosureRow";

import styles from "./AccordionGroup.module.scss";

interface Props {
    value: Value;
    headingTag: HeadingTag;
}

export const AccordionGroup = ({ value, headingTag }: Props) => {
    if (!value.items?.length) return <></>;
    return (
        <div className={styles.accordion}>
            <DisclosureGroup allowsMultipleExpanded className={styles.list}>
                {value.items.map((item, index) => (
                    <DisclosureRow
                        key={index}
                        title={item.title}
                        headingTag={headingTag}
                    >
                        {item.details ? (
                            <RichText value={item.details} />
                        ) : null}
                    </DisclosureRow>
                ))}
            </DisclosureGroup>
        </div>
    );
};
